import { render } from "./UiTextarea.vue?vue&type=template&id=881e8df2&scoped=true&lang=pug"
import script from "./UiTextarea.vue?vue&type=script&lang=js"
export * from "./UiTextarea.vue?vue&type=script&lang=js"

import "./UiTextarea.vue?vue&type=style&index=0&id=881e8df2&lang=sass&scoped=true"

import exportComponent from "D:\\Front\\project\\valeriya.artist\\valeriya.artist.admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-881e8df2"]])

export default __exports__